import React from "react";
import styles from "../assets/styles/aditi.module.css";
import { Box, Typography, Slider } from "@mui/material";

function CustomSlider({
  title,
  itemsList,
  setCallback,
  tooltipColor,
  sliderClasses,
  defaultValue,
  titleClass,
}) {
  // tooltip component for all types of indicator
  function ValueLabelComponent(props) {
    const { children, value } = props;
    const obj = itemsList.find((amount) => amount.value === value);
    return (
      <div
        className={styles.investCalToolTip}
        style={{ backgroundColor: tooltipColor }}
      >
        {obj?.displayText || obj?.label || value}
        {children}
      </div>
    );
  }
  return (
    <Box sx={{ width: "100%" }}>
      {/* title section */}
      <Typography className={titleClass || styles.calculatorTitle}>
        {title}
      </Typography>

      {/* slider section */}
      <Slider
        className={styles.amountSlider}
        aria-label="Small steps"
        step={null}
        defaultValue={defaultValue || itemsList[0]?.value}
        marks={itemsList}
        min={itemsList[0]?.value}
        onChange={(e) => {
          const obj = itemsList.find(
            (amount) => amount?.value === e?.target?.value
          );
          setCallback(obj?.displayValue);
        }}
        slots={{
          valueLabel: ValueLabelComponent,
        }}
        max={itemsList[itemsList.length - 1]?.value}
        valueLabelDisplay="on"
        classes={{
          thumb: sliderClasses?.thumb,
          rail: sliderClasses?.rail,
          track: sliderClasses?.track,
          mark: sliderClasses?.mark,
          markLabel: sliderClasses?.markLabel,
        }}
      />
    </Box>
  );
}

export default CustomSlider;
